/**
 * Fechas de entrenamientos en día local.
 * `new Date("YYYY-MM-DD")` se interpreta como medianoche UTC y en Argentina
 * corre el día hacia atrás. Los dateString guardados con toISOString() también
 * cambian de día después de las 21:00.
 */

export function parseFlexibleDate(value) {
  if (value == null || value === "") return null;

  if (typeof value.toDate === "function") {
    const parsed = value.toDate();
    return parsed instanceof Date && !Number.isNaN(parsed.getTime()) ? parsed : null;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (typeof value === "number" && Number.isFinite(value)) {
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    const dateOnly = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnly) {
      const parsed = new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]));
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }
    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  if (typeof value === "object") {
    const seconds = value.seconds ?? value._seconds;
    if (typeof seconds === "number" && Number.isFinite(seconds)) {
      const nanos = value.nanoseconds ?? value._nanoseconds ?? 0;
      const parsed = new Date(seconds * 1000 + Math.floor(nanos / 1e6));
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    }
  }

  return null;
}

export function formatLocalDateString(value) {
  const date = value instanceof Date && !Number.isNaN(value.getTime())
    ? value
    : parseFlexibleDate(value);
  if (!date) return null;
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

const TRAINING_DATE_WINDOW_MS = 36 * 60 * 60 * 1000;

/** Día en el que se entrenó. Si `date` se pisó al sincronizar, manda el inicio. */
export function getWorkoutTrainingDate(data) {
  if (!data || typeof data !== "object") return null;
  const start = parseFlexibleDate(data.startTime);
  const end = parseFlexibleDate(data.endTime);
  const date = parseFlexibleDate(data.date);
  const fromString = parseFlexibleDate(data.dateString);
  const created = parseFlexibleDate(data.createdAt);
  const anchor = start || end;

  if (anchor && date) {
    const diff = date.getTime() - anchor.getTime();
    if (Math.abs(diff) <= TRAINING_DATE_WINDOW_MS) return anchor;
    return date;
  }

  return anchor || date || fromString || created || null;
}

export function utcDateString(value) {
  const date = value instanceof Date && !Number.isNaN(value.getTime())
    ? value
    : parseFlexibleDate(value);
  if (!date) return null;
  return date.toISOString().split("T")[0];
}
